import Base from './Base';
import AccessRequest from '../models/AccessRequest';

export default class AccessRequests extends Base {
    get models() {
        const collection = this.data.map(item => new AccessRequest(item));
        collection.collection = this;

        return collection;
    }
}
